var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.type === 'internal' && !_vm.isMounted && _vm.to ? 'NuxtLink' : 'a',{tag:"component",staticClass:"bsg-link",class:{ functional: _vm.functional },attrs:{"id":_vm.trackingId,"to":_vm.type === 'internal' && !_vm.isMounted && _vm.to
      ? _vm.createInternalLink(_vm.to)
      : undefined,"href":_vm.type === 'external'
      ? _vm.to
      : _vm.type === 'internal' && _vm.to
      ? _vm.createInternalLink(_vm.to)
      : '#',"target":_vm.type === 'external' && !_vm.target ? '_blank' : _vm.target,"title":_vm.title ? _vm.title : undefined},on:{"click":_vm.callFunction}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }